import $ from 'jquery';
import prestashop from 'prestashop';

const typeMenu = {
  declinaison : '.declinaison',
  alternative: '.alternative',
  subscription: '.subscription'
};

$(document).ready(function () {
  createProductSpin();
  createInputFile();
  zoomImage();
  lightboxImage();
  coverImage();
  imageScrollBox();
  mobileImageScrollBox();
  moveProductAttributes();
  addAccordionActiveClass();
  initMenuFloat();
  initMenuOverlay();
  initSubscription();
  initMenuSubscription(false);
  initStickAddToCart();
  displayMoreCombination();
  responsiveBreakpoint();
  displayAlternative();
  moveSubscribeForm();

  $('body').on('change', '.product-variants *[name]', function () {
    togglePendingRefreshIcon('in');
  });

  prestashop.on('updatedProduct', function (event) {
    createInputFile();
    zoomImage();
    coverImage();
    imageScrollBox();
    mobileImageScrollBox();
    moveProductAttributes();
    initMenuFloat();
    refreshBlocks(event);
    displayMoreCombination();
    closeMenuFloat();
    displayAlternative();
    refreshStickyAddToCart(event);
    initSubscription();
    initMenuSubscription(true);

    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      let quantityInput = $(quantityInputSelector);

      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }

    $('#js_mfp_gallery').replaceWith(event.product_images_modal);
    lightboxImage();
    togglePendingRefreshIcon('out');

    if ($('[data-button-action="add-to-cart"]').is(':disabled')) {
      $('.product-add-to-cart').addClass('add-to-cart-disabled');
    } else {
      $('.product-add-to-cart').removeClass('add-to-cart-disabled');
    }
  });

  // varCustomActionAddToCart
  handleAddToCart();

});

var productResizeTimer;
$(window).resize(function() {
  clearTimeout(productResizeTimer);
  productResizeTimer = setTimeout(function() {
    zoomImage();
  }, 250);
});

function displayAlternative() {
  let nbProducts = $('#menu-float-alternative').find('.alternative-product');
  let btnDisplayAlertive = $('.js-alternative-products');

  if (nbProducts.length === 0) {
    btnDisplayAlertive.addClass('hide');
  } else {
    btnDisplayAlertive.removeClass('hide');
  }

}

function refreshBlocks(event) {
  let healthpointsLabel = $(event.product_add_to_cart).find('.product-healthpoints__label');
  let quantity = $(event.product_add_to_cart).find('.product-quantity-touchspin');

  if (healthpointsLabel.length > 0 && $(event.product_add_to_cart).find('.btn.btn-disabled').length === 0) {
    $('.product-healthpoints').removeClass('hide');
    $('.product-healthpoints__label').replaceWith(healthpointsLabel);
  } else {
    $('.product-healthpoints').addClass('hide');
  }
  if (quantity.hasClass('hide')) {
    $('.product-quantity-touchspin').addClass('hide');
  } else {
    $('.product-quantity-touchspin').removeClass('hide');
  }
}

function moveSubscribeForm() {
  $('.product-prescription').detach().insertBefore('.product-variants');
};

function responsiveSize(documentWidth) {
  let size = '';
  if (documentWidth > 992 && documentWidth <= 1220 && window.sld.redponsive != 'xl') {
    size = 'lg';
  } else if (documentWidth > 768 && documentWidth <= 992 && window.sld.redponsive != 'md') {
    size = 'md';
  } else if (documentWidth > 576 && documentWidth <= 768 && window.sld.redponsive != 'sm') {
    size = 'sm';
  } else if (documentWidth <= 576 && window.sld.redponsive != 'xs') {
    size = 'xs';
  } else {
    size = 'xl';
  }

  return size;
}

function responsiveBreakpoint() {
  window.sld.responsive = responsiveSize(window.innerWidth);

  window.addEventListener('resize', (e) => {
    let currentSize = responsiveSize(window.innerWidth);
    if (currentSize !== window.sld.responsive) {
      window.sld.responsive = currentSize;
      displayMoreCombination();
    }
  });
}

function moveCombinationActive(combinationsWidth, combintationsItemWidth) {
  let combitionActive = $('.product-information .combination-item.active');

  if (combitionActive.length > 0) {
    let positionCombitionActive = combitionActive.position().left;
  
    if (positionCombitionActive + combintationsItemWidth > combinationsWidth) {
      combitionActive.css('order', '-1');
    }
  }
}

function displayMoreCombination() {
  let combinationsWrapper =  $('.product-information .combinations-wrapper');
  let combintationsItems = $('.product-information .combination-item');

  if (combinationsWrapper.length > 0 && combintationsItems.length > 0) {
    let combinationsWidth =  combinationsWrapper.width();
    let combintationsItemWidth = combintationsItems.outerWidth();
    let btnMoreCombinations = $('.js-more-combinaison');
  
    if (window.innerWidth > 768) {
      if (combinationsWidth < (combintationsItemWidth * combintationsItems.length)) {
        btnMoreCombinations.removeClass('hide');
        moveCombinationActive(combinationsWidth, combintationsItemWidth);
      } else {
        btnMoreCombinations.addClass('hide');
      }
    }
  }
}

function initSubscription() {
  let selectFrequencies = document.querySelectorAll(`.product-information input[name="ciklik_type"]`);

  if (selectFrequencies.length > 0) {
    selectFrequencies.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let idAttribute = e.target.getAttribute('data-product-attribute');
        if (idAttribute !== null) {
          let attributeChoice = document.querySelector(`input[name="group[${idAttribute}]"][value="${e.target.value}"]`);
          let lastAttributeChoice = document.querySelector(`input[name="group[${idAttribute}]"]:checked`);
          let frequencyOptions = document.querySelectorAll(`.product-information input[name="group[${ciklik_frequency_id}]"]`);

          if (frequencyOptions.length > 0) {
            frequencyOptions.forEach((option) => {
              option.setAttribute('disabled', 'disabled');
            });
          }
          if(lastAttributeChoice !== null) {
            lastAttributeChoice.checked = false;
          }
          if (attributeChoice !== null) {
            attributeChoice.checked = true;
            togglePendingRefreshIcon('in');
            prestashop.emit('updateProduct', {
              eventType: 'updatedProductCiklikType',
              event: e
            });
          }
        }
      });
    });
  }
}

function initMenuOverlay() {
  $('.menu-float__overlay').on('click', (e) => {
    e.preventDefault();
    closeMenuFloat();
  });
}

function initMenuFloat() {

  $('.js-more-combinaison').on('click', (e) => {
    e.preventDefault();
    displayMenuFloat(typeMenu.declinaison);
  });

  $('.js-frequencies-subscription').on('click', (e) => {
    e.preventDefault();
    displayMenuFloat(typeMenu.subscription);
  });

  $('.js-alternative-products').on('click', (e) => {
    e.preventDefault();
    displayMenuFloat(typeMenu.alternative);
  });

  $('.js-close-menu-float').on('click', (e) => {
    e.preventDefault();
    closeMenuFloat();
  })
}

function insertOptionMenuSubscription(text, value, menu) {
  let label = document.createElement('label');
  let input = document.createElement('input');

  input.type = 'radio';
  input.value = value;
  input.setAttribute('name', `subscription-option`);
  input.setAttribute('id', `subscription-${value}`);
  input.addEventListener('click', (e) => {
    let attributeChoice = document.querySelector('input[name="group[12]"][value="' + e.target.value + '"]');
    let lastAttributeChoice = document.querySelector('input[name="group[12]"]:checked');

    if(lastAttributeChoice !== null) {
      lastAttributeChoice.checked = false;
    }
    if (attributeChoice !== null) {
      attributeChoice.checked = true;
    }
  });

  label.classList.add('js-subscription-option');
  label.setAttribute('for', `subscription-${value}`);
  label.innerHTML = `<span>${text}</span>`;
  label.prepend(input);
  menu.append(label);
}

function initMenuSubscription(update) {
  let selectFrequencies = document.querySelectorAll(`.product-information input[type="radio"][name="group[${ciklik_frequency_id}]"]`);
  let menuSubscription = document.querySelector('#menu-float-subscription');
  let productPrescription = document.querySelector('.product-prescription');
  let combinaisonActive = document.querySelector('.product-information .combination-item.active');
  let subscriptionRate = null;
  let prescriptionPets = null;
  let frequenciesDefault = null;
  let menuOptionDefault = null;

  if (menuSubscription !== null) {
    menuSubscription.innerHTML = '';
  }

  if (selectFrequencies.length > 0) {
    selectFrequencies.forEach((option) => {
      let optionText = option.closest('.custom-radio').querySelector('.text').innerText;
      let optionValue = option.value;
      insertOptionMenuSubscription(optionText, optionValue, menuSubscription);
      if (option.checked) {
        let menuOption = menuSubscription.querySelector(`input[value="${optionValue}"]`);
        if (menuOption !== null) {
          menuOption.checked = true;
        }
      }
    });
    if (update) {
      displayMenuFloat(typeMenu.subscription);

      let triggerButton = document.querySelector('.js-trigger-ciklick');
      let addToCartButton = document.querySelector('[data-button-action="add-to-cart"]');
      if (triggerButton !== null && addToCartButton !== null) {
        triggerButton.addEventListener('click', (e) => {
          e.preventDefault();
          addToCartButton.click();
        });
      }
    }
  }

  if (productPrescription !== null && combinaisonActive !== null) {
    let prescriptionDosage = productPrescription.dataset.dosage;
    let combinationWeight = combinaisonActive.dataset.weight;
    prescriptionPets = productPrescription.dataset.pets;
    if (prescriptionDosage && combinationWeight) {
      subscriptionRate = Math.floor(parseFloat(combinationWeight) / (parseFloat(prescriptionDosage)/1000) / 7);
    }
  }

  if (subscriptionRate && typeof ciklik_frequencies !== 'undefined') {
    frequenciesDefault = ciklik_frequencies.filter(
      frequency => parseInt(frequency.interval_count) === subscriptionRate && frequency.interval === 'week'
    );
    if (frequenciesDefault.length === 0) {
      frequenciesDefault = ciklik_frequencies.filter(
        frequency => parseInt(frequency.interval_count) === Math.floor(subscriptionRate / 4) && frequency.interval === 'month'
      )
    }
    if (frequenciesDefault.length === 0) { //find the nearest combination
      let weekFrequencies = ciklik_frequencies.filter(
        frequency => frequency.interval === 'week'
      )
      if (weekFrequencies.length > 0) {
        let closestFrequency = weekFrequencies.reduce((prev, curr) => {
          return (
            Math.abs(parseInt(curr.interval_count) - subscriptionRate) < Math.abs(parseInt(prev.interval_count) - subscriptionRate)
              ? curr
              : prev
          )
        })
        frequenciesDefault = [closestFrequency]
      }
    }

    if (frequenciesDefault.length > 0) {
      menuOptionDefault = menuSubscription.querySelector(`input[value="${frequenciesDefault[0].id_attribute}"]`);
      if(menuOptionDefault !== null) {
        menuOptionDefault.checked = true;
        let frequenciesInput = [...selectFrequencies].filter((i) => i.value === frequenciesDefault[0].id_attribute);
        frequenciesInput[0].checked = true;
        let infoPets = document.createElement('small');
        infoPets.innerText = `pour ${prescriptionPets}`;
        menuOptionDefault.parentElement.append(infoPets);
      }
    }
  }
}

function displayMenuFloat(type) {
  closeMenuFloat();
  $('.menu-float' + type).addClass('active');
  $('.menu-float__overlay').addClass('active');
}

function closeMenuFloat() {
  $('.menu-float__overlay.active').removeClass('active');
  $('.menu-float.active').removeClass('active');
}

function handleAddToCart() {
  $('body').off('click', '[data-button-action="add-to-cart"]');
  $('body').on('click', '[data-button-action="add-to-cart"]', function (event) {
    event.preventDefault();
    var $btn = $(this);
    var psAjaxCart = false;
    if (typeof(varPSAjaxCart) !== 'undefined' && varPSAjaxCart) {
      psAjaxCart = varPSAjaxCart;
    }

    if ($('#quantity_wanted').val() > $('[data-stock]').data('stock') && $('[data-allow-oosp]').data('allow-oosp').length === 0) {
      $btn.attr('disabled', 'disabled');
    } else {
      var _ret = (function () {
        let $form = $(event.target).closest('form');
        let query = $form.serialize() + '&add=1&action=update';
        let actionURL = $form.attr('action');

        let isQuantityInputValid = function($input) {
          var validInput = true;

          $input.each(function (index, input) {
            let $input = $(input);
            let minimalValue = parseInt($input.attr('min'), 10);
            if (minimalValue && $input.val() < minimalValue) {
              onInvalidQuantity($input);
              validInput = false;
            }
          });

          return validInput;
        };

        let onInvalidQuantity = function($input) {
          $input.parents('.product-add-to-cart').first().find('.product-minimal-quantity').addClass('error');
          $input.parent().find('label').addClass('error');
        };

        let $quantityInput = $form.find('input[min]');
        if (!isQuantityInputValid($quantityInput)) {
          onInvalidQuantity($quantityInput);

          return {
            v: undefined
          };
        }

        $btn.removeClass('added').addClass('disabled');

        $.post(actionURL, query, null, 'json').then(function(resp) {
          prestashop.emit('updateCart', {
            reason: {
              idProduct: resp.id_product,
              idProductAttribute: resp.id_product_attribute,
              idCustomization: resp.id_customization,
              linkAction: 'add-to-cart',
              cart: resp.cart,
              target: event.currentTarget
            },
            resp: resp
          });

          if (resp.success) {
            $btn.addClass('added');
            if (!psAjaxCart) {
              window.location.href = prestashop.urls.pages.cart + '?action=show';
            }
          }
          if (resp.hasError) {
            $('.js-modal-message-text').text(resp.errors[0]);
            $('.js-modal-message').modal('show');
          }
        }).fail(function (resp) {
          prestashop.emit('handleError', { eventType: 'addProductToCart', resp: resp });
        });
      })();

      if (typeof _ret === 'object') return _ret.v;
    }
  });
}

function togglePendingRefreshIcon(fade_status) {
  // varProductPendingRefreshIcon
  if (fade_status == 'in') {
    $('.js-product-refresh-pending-query').fadeIn();
  } else {
    $('.js-product-refresh-pending-query').fadeOut();
  }
}

function zoomImage() {
  $('#product .zoomWrapper .js-main-zoom').css('position','static').unwrap();
  $('#product .zoomContainer').remove();

  $('#product .js-enable-zoom-image .js-main-zoom').elevateZoom({
    zoomType: 'inner',
    gallery: 'js-zoom-gallery',
    galleryActiveClass: 'selected',
    imageCrossfade: true,
    cursor: 'crosshair',
    easing: true,
    easingDuration: 300,
    zoomWindowFadeIn: 500,
    zoomWindowFadeOut: 300,
  });
}

function lightboxImage() {
  var $gallery = $('#js_mfp_gallery');
  if ($gallery.length) {
    var zClose = $gallery.data('text-close'),
        zPrev = $gallery.data('text-prev'),
        zNext = $gallery.data('text-next');

    $('.js_mfp_gallery_item').magnificPopup({
      type: 'image',
      tClose: zClose,
      tLoading: '<div class="uil-spin-css"><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div>',
      removalDelay: 500,
      mainClass: 'mfp-fade',
      closeOnBgClick: true,
      gallery: {
        enabled: true,
        tPrev: zPrev,
        tNext: zNext,
        tCounter: '%curr% / %total%',
      },
      image: {
        verticalFit: false,
      }
    });

    $('.js-mfp-button').bind('click', function() {
      var imageId = $('#js-zoom-gallery .js-thumb.selected').data('id-image');
      $('.js_mfp_gallery_item').filter('[data-id-image="' + imageId + '"]').trigger('click');
    });
  }
}

function coverImage() {
  $('#product .js-cover-image .js-thumb, #quickviewProduct .js-thumb').on(
    'click',
    function (event) {
      $('.js-thumb.selected').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      $('.js-qv-product-cover').prop('src', $(event.currentTarget).data('image'));
    }
  );
}

function imageScrollBox() {
  $('.js-product-thumbs-scrollbox').makeFlexScrollBox();
}
function mobileImageScrollBox() {
  $('.js-mobile-images-scrollbox').makeFlexScrollBox();
}


/*function showHideScrollBoxArrows() {
  var thumbsWidth = 0;
  $('.js-qv-product-images .js-thumb-container').each(function() {
    thumbsWidth = thumbsWidth + $(this).outerWidth();
  });

  if (($('.js-qv-product-images').width() + 5) < thumbsWidth) {
    $('.scroll-box-arrows').addClass('scroll');
  } else {
    $('.scroll-box-arrows').removeClass('scroll');
  }
}*/

function createInputFile() {
  $('.js-file-input').on('change', function(event) {
    let target, file;

    if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
      $(target).prev().text(file.name);
    }
  });
}

function createProductSpin() {
  const $quantityInput = $('#quantity_wanted');
  $quantityInput.makeTouchSpin();

  $('body').on('change keyup', '#quantity_wanted', function (e) {
    $(e.currentTarget).trigger('touchspin.stopspin');
    $('.js-frequencies-subscription').attr('disabled', true)
    prestashop.emit('updateProduct', {
      eventType: 'updatedProductQuantity',
      event: e
    });
  });
}

function moveProductAttributes() {
  let $src = $('.js-product-attributes-source'),
      $dest = $('.js-product-attributes-destination'),
      $src2 = $('.js-product-availability-source'),
      $dest2 = $('.js-product-availability-destination');
  $dest.empty();
  if ($src.length) {
    $dest.html($src.html()); //$src.remove();
  }
  $dest2.empty();
  if ($src2.length) {
    $dest2.html($src2.html()); //$src2.remove();
  }
}

function addAccordionActiveClass() {
  $('.js-product-accordions [data-toggle="collapse"]').click(function() {
    $(this).closest('.panel').toggleClass('active');
  });
}

function initStickAddToCart() {
  const stickyAddToCart = document.querySelector('.js-sticky-add-to-cart');
  const observerAddToCart = document.querySelector('.product-add-to-cart');

  if (stickyAddToCart !== null && observerAddToCart !== null) {
    const callback = (entries) => {
      if (entries[0].isIntersecting) {
        stickyAddToCart.classList.remove('active');
      } else {
        stickyAddToCart.classList.add('active');
      }
    };

    const observerStickyMenu = new IntersectionObserver(callback, {rootMargin: '0px', threshold: 1.0});

    observerStickyMenu.observe(observerAddToCart);
  }
};

function refreshStickyAddToCart(e) {
  let btnAddToCart = $(e.product_add_to_cart).find('.btn-disabled');
  let btnAnchor =  $('.js-sticky-add-to-cart .sld-js-anchor');
    if (btnAddToCart.length > 0) {
      btnAnchor.removeClass('btn-primary');
      btnAnchor.addClass('btn-disabled');
      btnAnchor.text(btnAddToCart.text());
    } else {
      btnAnchor.removeClass('btn-disabled');
      btnAnchor.addClass('btn-primary');
      btnAnchor.text($(e.product_add_to_cart).find('.add-to-cart').text());
    }

}
